// extracted by mini-css-extract-plugin
export default {"container":"wo-z","ratingLayout":"xo-z","ratingLabel":"yo-z","nonInteractiveRatingLabel":"zo-z"};